'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = themer;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssThemr = require('react-css-themr');

var _dlv = require('dlv');

var _dlv2 = _interopRequireDefault(_dlv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function themer(namespace) {
    var defaultTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return function (ComposedComponent) {
        var Styled = function (_Component) {
            (0, _inherits3.default)(Styled, _Component);

            function Styled() {
                (0, _classCallCheck3.default)(this, Styled);
                return (0, _possibleConstructorReturn3.default)(this, (Styled.__proto__ || (0, _getPrototypeOf2.default)(Styled)).apply(this, arguments));
            }

            (0, _createClass3.default)(Styled, [{
                key: 'getStyling',

                /* eslint-enable react/forbid-prop-types */

                value: function getStyling() {
                    var stylesFromProps = (0, _dlv2.default)(this.props.styling, namespace);

                    if (stylesFromProps) {
                        return stylesFromProps;
                    }

                    return (0, _dlv2.default)(this.context, 'themr.styling.' + namespace, {});
                }

                /* eslint-disable react/forbid-prop-types */

            }, {
                key: 'render',
                value: function render() {
                    return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, {
                        styling: this.getStyling()
                    }));
                }
            }]);
            return Styled;
        }(_react.Component);

        Styled.displayName = 'Styled' + ComposedComponent.name;
        Styled.propTypes = {
            styling: _propTypes2.default.object };
        Styled.defaultProps = {
            styling: {}
        };
        Styled.contextTypes = {
            themr: _propTypes2.default.object
        };


        return (0, _reactCssThemr.themr)(namespace, defaultTheme, options)(Styled);
    };
}
//# sourceMappingURL=themer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/roc-package-hyperion/~/@spp/theme-provider/lib/cjs/themer.js
 ** module id = 552
 ** module chunks = 1
 **/